export default class rekaiprediction {
  constructor(element) {
    this.element = element;
    this.container = element.querySelector("[data-rekai-prediction]");
    if (!this.container) return;

    this.waitForRekai(() => {
      window.__rekai.ready(() => {
        this.fetchAndRender();
      });
    });
  }

  fetchAndRender() {
    const c = this.container;
    const nrofhits = c.dataset.nrofhits || "4";
    const excludetree = c.dataset.excludetree || "";
    const userootpath = c.dataset.userootpath || "false";
    const rootpathlevel = c.dataset.rootpathlevel || "1";
    const cols = c.dataset.cols || "2";
    const fallbackImgSrc = c.dataset.fallbackimgsrc || "";

    console.debug("[rekai-prediction] config:", { nrofhits, excludetree, userootpath, rootpathlevel, cols, fallbackImgSrc });

    const override = window.__rekai_predict_url_override;
    let url;

    if (override) {
      console.debug("[rekai-prediction] using predict_url_override:", override);
      const sep = override.indexOf("?") === -1 ? "?" : "&";
      url = override + sep + "nrofhits=" + nrofhits + "&addcontent=true";
    } else {
      const rekai = window.__rekai;
      const customer = JSON.parse(JSON.stringify(rekai.customer));
      const sendObj = rekai.buildSendObject(customer, {}, true, { isLink: false }, []);
      const params = rekai.getPredictionURLParameters({}, sendObj, customer);
      url = rekai.predictUrl + params + "&nrofhits=" + nrofhits + "&addcontent=true";
      console.debug("[rekai-prediction] using rekai API, customer:", customer);
    }

    if (excludetree) {
      url += "&excludetree=" + encodeURIComponent(excludetree);
    }
    if (userootpath === "true") {
      url += "&userootpath=true&rootpathlevel=" + rootpathlevel;
    }
    console.debug("[rekai-prediction] fetching:", url);

    fetch(url)
      .then((r) => {
        console.debug("[rekai-prediction] response status:", r.status);
        return r.json();
      })
      .then((data) => {
        console.debug("[rekai-prediction] raw response data:", data);
        const all = Array.isArray(data) ? data : (Array.isArray(data?.predictions) ? data.predictions : []);
        const items = all.slice(0, parseInt(nrofhits, 10));
        console.debug("[rekai-prediction] rendering", items.length, "of", all.length, "items into container:", c.id);
        this.render(items, cols, fallbackImgSrc);
      })
      .catch((err) => {
        console.error("rekai prediction fetch failed:", err);
      });
  }

  render(items, cols, fallbackImgSrc) {
    if (!items.length) return;

    const html = items
      .map((item) => {
        const title = item.title || "";
        const url = item.url || "#";
        const ingress = item.ingress || "";
        const image = item.imgurl || item.image || fallbackImgSrc;

        const imgHtml = image
          ? '<div class="post-related__image-wrapper">' +
              '<img src="' + this.escAttr(image) + '" alt="" />' +
            "</div>"
          : "";

        return (
          '<div class="post-related grid-col grid-col-100">' +
            imgHtml +
            '<div class="post-related__content">' +
              '<span class="post-related__title text-body">' +
                '<a href="' + this.escAttr(url) + '" rel="bookmark">' +
                  this.escHtml(title) +
                '</a>' +
              '</span>' +
              (ingress
                ? '<div class="post-related__body">' +
                    '<p>' + this.escHtml(ingress) + '</p>' +
                  '</div>'
                : '') +
            '</div>' +
          '</div>'
        );
      })
      .join("");

    this.container.innerHTML =
      '<div class="related-pages u-container">' +
        '<h2 class="title title--block text-display-4">Läs även</h2>' +
        '<div class="grid-row related-pages__inner">' + html + '</div>' +
      '</div>';
  }

  escAttr(str) {
    return str
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  escHtml(str) {
    return str
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  waitForRekai(callback) {
    if (typeof window.__rekai !== "undefined") {
      callback();
      return;
    }
    const observer = new MutationObserver((mutations, obs) => {
      if (typeof window.__rekai !== "undefined") {
        obs.disconnect();
        clearTimeout(timeout);
        callback();
      }
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
    const timeout = setTimeout(() => {
      observer.disconnect();
      console.error("rekai: script did not load within 30s");
    }, 30000);
  }
}
